// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 20:43:14

export default {
  "id": "killer-escape-huggy-extreme",
  "slug": "killer-escape-huggy-extreme",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/ec07fa0058b14dc1809e9d93c0128cfc-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/ec07fa0058b14dc1809e9d93c0128cfc/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Killer Escape Huggy Extreme",
      "description": "This game is extremely more difficult and filled with challenges compared to the previous one. You need to become Huggy and catch all your clones. Catch all the clones and hunt them down, but remember, some of them must be thrown out of the maze. No one should see you, and you must not get caught while hunting someone. Be very careful, the clones are everywhere and extremely dangerous. Some doors can only be opened by you. Open the doors and hunt the clones. ",
      "instructions": "*Use the \"arrow keys\" to move.\n*Press the \"Space\" key to kill someone.\n*Playable on both mobile and PC.\n*Collect energy boxes, extend the mission time.",
      "genres": [
        "Battle"
      ],
      "tags": [
        "2d",
        "amongus",
        "arcade",
        "monster",
        "survival"
      ]
    },
    "zh-CN": {
      "title": "致命逃脱 毛茸茸极限",
      "description": "这款游戏比上一款难度极高，充满了挑战。你需要变成Huggy，捕捉所有你的克隆体。捕捉所有克隆体并追捕它们，但记住，其中一些必须被扔出迷宫。没有人应该看到你，你在追捕某人时也不能被抓到。要非常小心，克隆体无处不在，极其危险。有些门只能由你打开。打开门并追捕克隆体。",
      "instructions": "*使用“方向键”移动。\n*按“空格键”杀死某人。\n*可在移动设备和PC上玩。\n*收集能量箱，延长任务时间。",
      "genres": [
        "战斗"
      ],
      "tags": [
        "2D",
        "Among Us",
        "街机",
        "怪物",
        "生存"
      ]
    },
    "zh-TW": {
      "title": "殺手逃亡 拥抱極端",
      "description": "這款遊戲比起上一款難度極高，充滿挑戰。你需要變成Huggy並捕捉所有你的複製體。捕捉所有複製體並追捕他們，但記住，有些複製體必須被丟出迷宮。沒人應該看到你，並且你在追捕某人的時候不應該被逮到。非常小心，複製體无处不在且非常危險。有些門只有你能打開。打開門並追捕複製體。",
      "instructions": "*使用「方向鍵」來移動。\n*按「空格鍵」殺死某人。\n*可在手機和平板電腦上遊玩。\n*收集能量箱，延長任務時間。",
      "genres": [
        "戰鬥"
      ],
      "tags": [
        "2D",
        "我們都是船員",
        "街機",
        "怪物",
        "生存"
      ]
    },
    "zh-HK": {
      "title": "殺手逃離親親極限版",
      "description": "這款遊戲比起上一款難度極高，充滿挑戰。你需要變成Huggy，捕捉所有的複製體。捕捉所有複製體並追蹤他們，但記住，其中一些必須被丟出迷宮。絕對不要讓人看到你，在追捕某人的時候也不可被捕捉。要非常小心，複製體无处不在，非常危險。有些門只有你能打開。打開門並追捕複製體。",
      "instructions": "*使用「方向鍵」移動。\n*按「空格鍵」殺死某人。\n*可在手機及電腦上遊玩。\n*收集能量箱，延長任務時間。",
      "genres": [
        "戰鬥"
      ],
      "tags": [
        "2D",
        "Among Us",
        "街機",
        "怪物",
        "生存"
      ]
    },
    "ja": {
      "title": "キラーエスケープハギーextreme",
      "description": "このゲームは前作よりも非常に難しく、多くの挑戦が用意されています。ヒッギーになり、全てのクローンを捕まえる必要があります。クローンを全て捕まえ、追いかけ続けますが、覚えておいてください。中には迷路から追い出すべきクローンもいます。誰にも見られず、追いかけた相手に捕まってはなりません。非常に慎重に、クローンは至る所に存在し、非常に危険です。いくつかの扉はあなたしか開けられません。扉を開け、クローンを追いかけましょう。",
      "instructions": "*「アーロウキー」を使用して移動してください。\n*「スペースキー」を押して誰かを殺してください。\n*モバイルとPC両方でプレイ可能です。\n*エネルギーボックスを収集して、ミッション時間を延ばしてください。",
      "genres": [
        "バトル"
      ],
      "tags": [
        "2D",
        "アモンアス",
        "アーケード",
        "モンスター",
        "サバイバル"
      ]
    },
    "ko": {
      "title": "기어러 Escape Huggy 엑스트라임",
      "description": "이 게임은 이전 게임보다 훨씬 더 어렵고 도전적인 편입니다. 휸지가 되어 모든 복제체를 잡아야 합니다. 모든 복제체를 잡고 추적하되, 기억하시오, 일부 복제체는 루프에서 내려야 합니다. 누구도 당신을 보지 않도록 해야 하며, 추적 중 누구도 잡히지 않도록 조심해야 합니다. 매우 조심스럽게 하세요, 복제체는 어디에나 있고 매우 위험합니다. 일부 문은 당신만이 열 수 있습니다. 문을 열고 복제체를 추적하세요.",
      "instructions": "*아이콘 키를 사용하여 이동하세요.\n*스페이스 바튼을 눌러서 사람을 죽이세요.\n*모바일과 PC 모두에서 플레이 가능합니다.\n*에너지 상자를 수집하여 미션 시간을 연장하세요.",
      "genres": [
        "전투"
      ],
      "tags": [
        "2D",
        "어몽어스",
        "아케이드",
        "몬스터",
        "생존"
      ]
    },
    "fr": {
      "title": "Échappée Meurtrière Huggy Extrême",
      "description": "Ce jeu est extrêmement plus difficile et rempli de défis par rapport à celui précédent. Vous devez devenir Huggy et attraper tous vos clones. Attrapez tous les clones et les traquez, mais souvenez-vous, certains d'entre eux doivent être jetés hors du labyrinthe. Personne ne doit vous voir, et vous ne devez pas être pris pendant que vous traquez quelqu'un. Soyez très prudent, les clones sont partout et extrêmement dangereux. Certaines portes ne peuvent être ouvertes que par vous. Ouvrez les portes et traquez les clones.",
      "instructions": "*Utilisez les \"touches flèches\" pour vous déplacer.\n*Appuyez sur la touche \"Espace\" pour tuer quelqu'un.\n*Jouable sur mobile et PC.\n*Collectez des boîtes d'énergie pour prolonger la durée de la mission.",
      "genres": [
        "Bataille"
      ],
      "tags": [
        "2D",
        "Among Us",
        "arcade",
        "monstre",
        "survie"
      ]
    }
  }
};
